// extracted by mini-css-extract-plugin
module.exports = {"root":"FacetsFilter_root__hB2ct"};